export enum ConfiguratorStep {
  ProductPage,
  Configurator,
  HalfConfigurator,
  ExtraOptions,
}
